
<template>
  



<v-footer
      
      padless
      
      
    >

 <v-row no-gutters>
      
      <v-col>
      
      <v-card
        flat
        tile
        class="lighten-1 grey--text text-center"

     
      
      >


  <!--    <span>
  ¿Quieres algo parecido? Puedes hacerlo tú mismo gratuitamente
  <a
    :href="$router.resolve({ path: '/' }).href"
    class="no-underline"
    style="color: blue;"
  >
    aquí
  </a>
</span>-->






        <v-card-text>
          <!-- <v-btn
           v-for="(item,i) in ChapterDetails.socialLinks" :key="i.name"
            class="mx-4"
            icon
          
             color="deep-purple accent-4"
          >
            <v-btn  icon :href="item.link" target="_blank" >
                    <v-icon>{{item.icon}}</v-icon>
                  </v-btn>
                  


          </v-btn> -->
        </v-card-text>
  
        <v-card-text class="gray--text pt-0">
    <!-- Página creada gratuitamente con: -->
    <!-- <a :href="$router.resolve({ path: '/' }).href" target="_blank" rel="noopener noreferrer" class="no-underline"> -->
      <!-- TecZoa -->
    <!-- </a> -->

    
    <!-- target="_blank" rel="noopener noreferrer"  -->
        </v-card-text>

        <a :href="$router.resolve({ path: '/' }).href"class="no-underline">
          <img src="@/assets/img/use/logoteczoav1.png" alt="Logo TecZoa" style="width: 80px; margin-top: 0px;">
    </a>
       
        
        <v-divider></v-divider>
  
        <v-card-text class="gray--text">
          {{ new Date().getFullYear() }}
        </v-card-text>
      </v-card>


        </v-col>
        
      </v-row>
    </v-footer>









</template>

<script>
  import ChapterDetails from '@/assets/data/chapterDetails.json'
 
  export default {
    data() {
      return {
        ChapterDetails:ChapterDetails
      }
    },
  }
</script>


<style>
.no-underline {
  text-decoration: none; /* Elimina el subrayado */
  color: inherit; /* Mantiene el color del texto fuerte */
}
</style>


